import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';
import { ContratosService } from 'src/app/service/contratos.service';
import { DialogData } from 'src/app/usuarios/atualizar-usuario/atualizar-usuario.component';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {

  confirmacao: FormGroup;
  contratoConfirmar:any;

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,fb: FormBuilder,
    private contratoService: ContratosService,private alertService: AlertService,) { 
      this.confirmacao = fb.group({
        ciente: false,
      });
    }

  contratos = [] as any;
  flag = true;

  ngOnInit(): void {
    var payKey = Object.keys(this.data);
    var payValor = Object.values(this.data)
    payKey.forEach((element, index) => {
      this.contratos.push({'produto': element, 'contratos': payValor[index]})
    });
    this.confirmacao.valueChanges.subscribe(selectedValue  => {
      if(selectedValue.ciente == true){
        this.flag = false
      }else{
        this.flag = true
      }
    })
  }

  confirmacaoAviso(){
    var array = [] as any;
    this.contratos.forEach((element:any) => {
      element.contratos.forEach((dados:any) => {
        var json = {'clienteId': dados.fk_cliente, 'contratoId': dados.sr_id, 'dias': dados.avisoDe}
        array.push(json);
      });
    });
    this.contratoService.marcarVisualizacao(array).subscribe(
      (resp:any) =>{
        this.alertService.success();
        this.dialogRef.close();
    })
  }
}
